import { ValidatorFn, Validators } from '@angular/forms';
import { Observable } from 'rxjs';

import { Validator } from '../decorators/validator.decorator';
import { IValidatorOptions } from '../interfaces';
import { IValidatorError } from '../interfaces/validator-error.interface';

import { CustomValidators } from './custom-validators.class';

type ValidatorFactory = (params: IValidatorOptions) => ValidatorFn;

export class IdealsValidators {
  @Validator(CustomValidators.confirmPasswordValidator)
  static confirm: (options: { error: IValidatorError; }) => ValidatorFn;
  @Validator(CustomValidators.digitOrSpecChars)
  static digitOrSpecChars: (digitOrSpecChars: number, options: { error: IValidatorError; }) => ValidatorFn;
  @Validator(CustomValidators.digitsAndLatinOnly)
  static digitsAndLatinOnly: (options: { error: IValidatorError; }) => ValidatorFn;
  @Validator(Validators.email)
  static email: (options: { error: IValidatorError; }) => ValidatorFn;
  @Validator(CustomValidators.emailAddressValidator)
  static emailAddress: (options: { error: IValidatorError; }) => ValidatorFn;
  @Validator(CustomValidators.lowercaseLetter)
  static lowercaseLetter: (lowercaseLetter: number, options: { error: IValidatorError; }) => ValidatorFn;
  @Validator(Validators.max)
  static max: (max: number, options: { error: IValidatorError; }) => ValidatorFn;
  @Validator(Validators.maxLength)
  static maxLength: (maxLength: number, options: { error: IValidatorError; }) => ValidatorFn;
  @Validator(Validators.min)
  static min: (min: number, options: { error: IValidatorError; }) => ValidatorFn;
  @Validator(Validators.minLength)
  static minLength: (minLength: number, options: { error: IValidatorError; }) => ValidatorFn;
  @Validator(Validators.nullValidator)
  static nullValidator: (options: { error: IValidatorError; }) => ValidatorFn;
  @Validator(Validators.pattern)
  static pattern: (pattern: string | RegExp, options: { error: IValidatorError; }) => ValidatorFn;
  @Validator(Validators.required)
  static required: (options: { error: IValidatorError; }) => ValidatorFn;
  @Validator(Validators.requiredTrue)
  static requiredTrue: (options: { error: IValidatorError; }) => ValidatorFn;
  @Validator(CustomValidators.specCharValidator)
  static specChar: (options: { error: IValidatorError; }) => ValidatorFn;
  @Validator(CustomValidators.uppercaseLetter)
  static uppercaseLetter: (uppercaseLetter: number, options: { error: IValidatorError; }) => ValidatorFn;
  @Validator(CustomValidators.whitespaceValidator)
  static whitespace: (options: { error: IValidatorError; }) => ValidatorFn;

  static getArrayValidators(options: { validatorName: string; params: IValidatorOptions; }[]): ValidatorFn[] {
    return options.map((option) => {
      const validatorFactories = IdealsValidators as unknown as Record<string, ValidatorFactory>;

      return validatorFactories[option.validatorName](option.params);
    });
  }

  static getRequiredValidator(requireErrorText: Observable<string>): ValidatorFn[] {
    return IdealsValidators.getArrayValidators([
      { validatorName: 'required', params: { validatorParameters: [], error: { text: requireErrorText } } },
    ]);
  }

  static getRequiredWhitespaceSpecCharValidator(
    requireErrorText: Observable<string>,
    specCharErrorText: Observable<string>,
    whitespaceErrorText?: Observable<string>
  ): ValidatorFn[] {
    return [
      ...IdealsValidators.getArrayValidators([
        { validatorName: 'specChar', params: { validatorParameters: [], error: { text: specCharErrorText } } },
      ]),
      ...IdealsValidators.getRequiredWhitespaceValidator(requireErrorText, whitespaceErrorText),
    ];
  }

  static getRequiredWhitespaceValidator(requireErrorText: Observable<string>, whitespaceErrorText?: Observable<string>): ValidatorFn[] {
    const whitespaceText = whitespaceErrorText ? whitespaceErrorText : requireErrorText;

    return [
      ...IdealsValidators.getRequiredValidator(requireErrorText),
      ...IdealsValidators.getArrayValidators([
        { validatorName: 'whitespace', params: { validatorParameters: [], error: { text: whitespaceText } } },
      ]),
    ];
  }
}
